module.exports = __webpack_public_path__ + "static/media/green.e4e17521.png";